module.exports = __webpack_public_path__ + "img/illu-stitches-head.3c2d7d6a.svg";